import FlowWizard from '@shared/components/form/FlowWizard';
import { ActivityName } from 'app/_modules/core/types';
import { useMeasurementFlow, EActivitySubmitSteps } from 'app/_modules/core/hooks/useMeasurementFlow';

export { EActivitySubmitSteps };

const MeasurementFlow = ({
  activityName,
  activityId,
  initialStep = 0,
  forceReset = false,
  isRemeasurement = false,
  autoStartWebSocket = false,
}: {
  activityName: ActivityName;
  activityId: string;
  initialStep?: number;
  forceReset?: boolean;
  isRemeasurement?: boolean;
  autoStartWebSocket?: boolean;
}) => {
  const { steps, webSocketConfig, backButton, finishButton, resolvedInitialStep, handleFinish } =
    useMeasurementFlow({ activityName, activityId, initialStep, forceReset, isRemeasurement, autoStartWebSocket });

  return (
    <FlowWizard
      steps={steps}
      onFinish={handleFinish}
      animationType="scale"
      initialStep={resolvedInitialStep}
      layout="vertical"
      customButtons={{
        backButton,
        finishButton,
      }}
      webSocketConfig={webSocketConfig}
    />
  );
};

export default MeasurementFlow;
